import { CheckCircle2, X } from 'lucide-react';
import { useState, type FormEvent } from 'react';

/** Completing a task always requires a note — the creator's WhatsApp notification and the task
 * detail page both surface it, so silently marking done with no record of what was done isn't
 * an option here. */
export function CompleteTaskModal({ taskTitle, isPending, onConfirm, onClose }: { taskTitle: string; isPending: boolean; onConfirm: (note: string) => void; onClose: () => void }) {
  const [note, setNote] = useState('');

  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (note.trim()) onConfirm(note.trim());
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose}>
      <form className="w-full max-w-md rounded-2xl bg-white p-5 shadow-card" onClick={(e) => e.stopPropagation()} onSubmit={submit}>
        <div className="mb-4 flex items-start justify-between gap-3">
          <div>
            <h3 className="font-bold">Complete task</h3>
            <p className="truncate text-sm text-muted">{taskTitle}</p>
          </div>
          <button type="button" aria-label="Close" onClick={onClose} className="text-muted hover:text-ink"><X size={20} /></button>
        </div>
        <label className="label">
          Completion note
          <textarea
            className="field mt-1 min-h-24 py-2"
            required
            autoFocus
            maxLength={1000}
            placeholder="What did you do to complete this task?"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </label>
        <div className="mt-4 flex justify-end gap-2">
          <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn-primary" disabled={isPending || !note.trim()}><CheckCircle2 size={18} /> Mark complete</button>
        </div>
      </form>
    </div>
  );
}
